export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD hh:mm:ss";
export const MAX_PRICE = 999999.99;
export const DINE_IN = "dine_in";
export const IN_STORE = "in_store";
export const ASAP = "ASAP";
export const HALF_SECOND_IN_MS = 500;
